<template>
  <div>
    <HMTTour360Provider />
  </div>
</template>

<script>
  import HMTTour360Provider from '@/shared/components/Tour360Provider';
  
  export default {
    name: 'Tour360',
    components: {
      HMTTour360Provider
    }
  };
</script>
